import { createHashRouter } from "react-router-dom";

import Home from "../pages/home";
import Login from "../pages/login";
import NotFound from "../pages/notfound";
import Register from "../pages/register";
import RegisterPAYG from "../pages/register_payg";
import RegisterConfirm from "../pages/registerconfirm";
import ExamStart from "../pages/examstart";
import ExamLanding from "../pages/examlanding";
import Question from "../pages/question";
import SectionComplete from "../pages/sectioncomplete";
import ExamComplete from "../pages/examcomplete";
import ExamResults from "../pages/results";
import MaxRetry from "../pages/maxretry";
import SectionEnd from "../pages/sectionend";
import Coupon from "../pages/coupon";
import RegisterPay from "../pages/pay";
import LoadError from "./error";
import Admin from "../pages/admin";
import Dashboard from "../pages/dashboard";
import PayConfirm from "../pages/payconfirm";
import ForgotPassword from "../pages/forgotpassword";
import QuestionPreview from "../pages/questionpreview";

const routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgot-password",  
    element: <ForgotPassword />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/register_payg",
    element: <RegisterPAYG />
  },
  {
    path:"/register-coupon",
    element: <Coupon />,
  },
  {
    path:"/register-pay",
    element: <RegisterPay />,
  },
  {
    path: "/register-confirm",
    element: <RegisterConfirm />,
  },
  {
    path: "/pay-confirm",
    element: <PayConfirm />,
  },
  {
    path: "/exam-start",
    element: <ExamStart />,
  },
  {
    path: "/exam-landing",
    element: <ExamLanding />,
  },
  {
    path: "/question/:questionid",
    element: <Question />,
  },
  {
    path: "/questionpreview/:examid/:questionid",
    element: <QuestionPreview />,
  },
  
  {
    path: "/section-complete",
    element: <SectionComplete />,
  },
  {
    path: "/exam-complete",
    element: <ExamComplete />,
  },
  {
    path: "/exam-results",
    element: <ExamResults />,
    errorElement: <LoadError />
  },
  {
    path: "/admin",
    element: <Admin />,
    errorElement: <LoadError />
  },
  {
    path: "max-retry",
    element: <MaxRetry />,
  },
  {
    path: "section-end",
    element: <SectionEnd />,
  },
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

const router = createHashRouter(routes, {
  basename: "/",
});

export default router;
